import React, { useState, useEffect } from "react";
import NavBar from "../../../../components/NavBarAdmin";
import DashboardRequest from "./DashboardAdminRequests";
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { color } from "highcharts";
import { XAxis } from "recharts";

// Registrando os componentes do Chart.js que iremos usar
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


const DashboardAdmin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        usersActive: 0,
        venuesActive: 0,
        eventsActive: 0,
        saldoSMS: 0,
        usersGrowth: [],
    });

    useEffect(() => {
        const fetchData = async () => {
            let info = await DashboardRequest.getDashboard();
            if (info && info.status) {
                setData(info.data);
            }
            setIsLoading(false);
        };
        fetchData();
    }, []);

    const UserGrowth = () => {
        const labels = data.usersGrowth.map(entry => {
            const [year, month] = entry.month.split('-');
            return `${month}/${year}`;
        });

        const dataGraph = {
            labels,
            datasets: [
                {
                    label: 'Utilizadores por Mês',
                    data: data.usersGrowth.map(entry => entry.total),
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.2,
                },
            ],
        };

        const options = {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',

                },
                title: {
                    display: true,
                    text: 'Crescimento Mensal de Utilizadores',
                    color: "#ffffff",
                },
                scales: {
                    xAxis: {
                        color: "#ffffff",
                    },
                    yAxis: {
                        color: "#ffffff",
                    },
                }
            },
        };

        return (
            <div className="">
                <Line data={dataGraph} options={options} />
            </div>
        );
    }


    const RevenueGrowth = () => {
        const labels = data.revenueGrowth.map(entry => {
            const [year, month] = entry.month.split('-');
            return `${month}/${year}`;
        });

        const dataGraph = {
            labels,
            datasets: [
                {
                    label: 'Faturação Mensal',
                    data: data.revenueGrowth.map(entry => entry.total),
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.2,
                },
                {
                    label: 'Lucro Mensal',
                    data: data.revenueGrowth.map(entry => entry.total_liquido),
                    fill: false,
                    borderColor: 'rgb(36, 252, 3)',
                    tension: 0.2,
                }
            ],
        };

        const options = {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',

                },
                title: {
                    display: true,
                    text: 'Faturação Mensal',
                    color: "#ffffff",
                },
                scales: {
                    xAxis: {
                        color: "#ffffff",
                    },
                    yAxis: {
                        color: "#ffffff",
                    },
                }
            },
        };

        return (
            <div className="">
                <Line data={dataGraph} options={options} />
            </div>
        );
    }

    const VenuesBalance = () => {
        return (
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Venue</th>
                        <th>Balance</th>
                        <th>Hold</th>
                    </tr>
                </thead>
                <tbody>
                    {data.venuesBalance.map((venue, index) => (
                        <tr key={index}>
                            <td>{venue.name}</td>
                            <td>{venue.balance_total}</td>
                            <td>{venue.balance_hold}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    return (isLoading ? <div className="loading">Loading...</div> : null) || (
        <div>
            <NavBar >
                <div className="row">
                    <div className="col-12 dashboard-content">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                                <div className="card box-dashboard p-3">
                                    <h4 className="card-title">Users</h4>
                                    <h2 className="float-end">{data.usersActive}</h2>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                                <div className="card box-dashboard p-3">
                                    <h4 className="card-title">Venues</h4>
                                    <h2 className="float-end">{data.venuesActive}</h2>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                                <div className="card box-dashboard p-3">
                                    <h4 className="card-title">Events</h4>
                                    <h2 className="float-end">{data.eventsActive}</h2>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                                <div className="card box-dashboard p-3">
                                    <h4 className="card-title">Saldo SMS</h4>
                                    <h2 className="float-end">{data.saldoSMS}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-6 dashboard-content">
                        <div className="card box-dashboard ">
                            <UserGrowth />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 dashboard-content">
                        <div className="card box-dashboard ">
                            <VenuesBalance />
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-12 dashboard-content">
                        <div className="card box-dashboard ">
                            <RevenueGrowth />
                        </div>
                    </div>
                </div>

            </NavBar>
        </div>

    );
};

export default DashboardAdmin;
